export const WHATSAPP_NUMBER = "5212284081782";

export const whatsappLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

export const NAV_LINKS = [
  { label: "Equipamiento", href: "/#equipamiento" },
  { label: "Nosotros", href: "/nosotros" },
  { label: "Aventuras", href: "/nosotros#aventuras" },
  { label: "Opiniones", href: "/#voces" },
  { label: "Garantías", href: "/#compra-segura" },
  { label: "Contacto", href: "/contacto" },
  { label: "Blog", href: "/blog" },
];

export const CATEGORIES = [
  "Todos",
  "Energía Solar",
  "Camping",
  "Ciclismo",
  "Electrónica",
  "Pesca",
  "Senderismo",
];

export const SOCIALS = [
  { label: "Facebook", href: "https://www.facebook.com/share/18RRu62cYq/", testid: "social-facebook" },
  { label: "Instagram", href: "https://www.instagram.com/ruta.deportiva.360/", testid: "social-instagram" },
  { label: "Threads", href: "https://www.threads.com/@ruta.deportiva.360", testid: "social-threads" },
  { label: "TikTok", href: "https://www.tiktok.com/@ruta.deportiva.360", testid: "social-tiktok" },
  { label: "Pinterest", href: "https://pin.it/2jGcoReT5", testid: "social-pinterest" },
];

export const MARQUEE_ITEMS = [
  "Pesca",
  "Kayaks",
  "Ciclismo",
  "Camping",
  "GPS Garmin",
  "Bocinas JBL",
  "Drones",
  "Energía Solar",
];

export const MANIFESTO = [
  {
    number: "01",
    title: "Un negocio familiar",
    body: "Ruta 360 es un negocio familiar. Nació de las ganas de darle un giro completo a nuestra vida. Durante un tiempo, quien hoy está al frente estuvo viajando por distintos países, cambiando de ruta una y otra vez. Al regresar quiso aterrizar todo eso en algo concreto y, al mismo tiempo, cuidar mejor su salud.",
  },
  {
    number: "02",
    title: "Usamos lo que vendemos",
    body: "Fuimos deportistas a nivel nacional y nos sigue gustando lo mismo: la naturaleza, ir de camping, movernos. Los productos que vendemos los usamos nosotros, por eso podemos decirte cómo funcionan de verdad. Te atiende una persona, no un bot, y en 2026 ya enviamos más de 50 pedidos a domicilio desde Xalapa, Veracruz.",
  },
  {
    number: "03",
    title: "¿Por qué Ruta 360?",
    body: "Porque es la ruta de nuestra vida. Y porque toda gran ruta, por más vueltas que dé, te termina llevando al mismo punto. Lo que más queremos es que compres tranquilo: que tu pedido llegue completo y que sea de calidad.",
  },
];

export const GALLERY = [
  {
    src: "https://images.unsplash.com/photo-1625834509314-3b12c6153624?auto=format&fit=crop&w=1200&q=80",
    alt: "Explorador junto a su carpa al amanecer",
    location: "Valle de Bravo, EDOMEX",
    span: "tall",
  },
  {
    src: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606?auto=format&fit=crop&w=1200&q=80",
    alt: "Cordillera entre niebla",
    location: "Sierra Gorda, QRO",
    span: "wide",
  },
  {
    src: "https://images.unsplash.com/photo-1619704850762-d2bbdb5b94ee?auto=format&fit=crop&w=1200&q=80",
    alt: "Carpa iluminada en la noche",
    location: "Nevado de Toluca, MEX",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1492648272180-61e45a8d98a7?auto=format&fit=crop&w=1200&q=80",
    alt: "Descanso en la cima junto a la carpa",
    location: "Barrancas del Cobre, CHIH",
    span: "normal",
  },
  {
    src: "https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7?auto=format&fit=crop&w=1200&q=80",
    alt: "Campamento al atardecer",
    location: "Real de Catorce, SLP",
    span: "wide",
  },
  {
    src: "https://images.unsplash.com/photo-1517824806704-9040b037703b?auto=format&fit=crop&w=1200&q=80",
    alt: "Sendero entre el bosque",
    location: "El Chico, HGO",
    span: "tall",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "La Sierra XT subió el Nevado como si nada. Les escribí por WhatsApp un lunes y el viernes ya estaba estrenándola en la brecha.",
    name: "Mariana G.",
    route: "Nevado de Toluca",
  },
  {
    quote:
      "Cinco días en la Barranca del Cobre con el Basecamp 500: drones, lámparas y tres teléfonos siempre cargados. No volvimos a ver un enchufe.",
    name: "Diego R.",
    route: "Barrancas del Cobre",
  },
  {
    quote:
      "Se nos voló la bocina al río en Valle de Bravo. La sacamos, la sacudimos y siguió sonando toda la noche. Eso es equipo de verdad.",
    name: "Fernanda L.",
    route: "Valle de Bravo",
  },
];
